













import { Component, Mixins } from "vue-property-decorator";
import { DateObjectKinds, DateFormatKinds, TimeFormatKinds } from "../../../../../../documaker/domain/format/objects";
import { DateTextDrawableObjectDrawerBase } from "./base";
import { DateStylePropertyEditableMixin, TimeStylePropertyEditableMixin, HisInformationKeyPropertyEditableMixin, UserDefinedInformationKeyPropertyEditableMixin } from "../../mixins";
import { ObjectKeys } from "../../../../../domain/configuration";
import { DateObjectEditor } from "../../../../../domain/editableFormat/objectEditors";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class DateObjectDrawer extends Mixins(DateTextDrawableObjectDrawerBase, DateStylePropertyEditableMixin, TimeStylePropertyEditableMixin, HisInformationKeyPropertyEditableMixin, UserDefinedInformationKeyPropertyEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: DateObjectEditor) => T, defaultValue: T) => T;

  get displayName(): string {
    switch (this.objectKind) {
      case DateObjectKinds.HisItem:
        return this.hisInformationName;
      case DateObjectKinds.UserDefined:
        return this.userDefinedInformationName;
      default:
        return this.isDate
          ? this.dateFormat
          : this.timeFormat;
    }
  }

  get configurationKey(): ObjectKeys {
    switch (this.objectKind) {
      case DateObjectKinds.Normal:
        return this.isDate
          ? "Date"
          : "Time";
      case DateObjectKinds.HisItem:
        return this.isDate
          ? "HisDate"
          : "HisTime";
      case DateObjectKinds.UserDefined:
        return "UserDefinedDate";
      default:
        return "NotImplemented";
    }
  }

  get objectKind(): DateObjectKinds {
    return this.readPropertyOrDefault(s => s.objectKind().getValue(), DateObjectKinds.Normal);
  }

  get isDate(): boolean {
    return this.readPropertyOrDefault(s => s.isDate().getValue(), true);
  }

  get dateFormat(): string {
    const weekDay = this.dateStyle.hasWeekDay ? " （　）" : "";
    switch (this.dateStyle.formatKind) {
      case DateFormatKinds.ymdStringAd:
        return "9999 年 99 月 99 日" + weekDay;
      case DateFormatKinds.ymdStringJcEra:
        return "和暦 99 年 99 月 99 日" + weekDay;
      case DateFormatKinds.ymdStringJc:
        return "99 年 99 月 99 日" + weekDay;
      case DateFormatKinds.ymdSlashAd:
        return "9999 / 99 / 99" + weekDay;
      case DateFormatKinds.ymdSlashJcE:
        return "99 / 99 / 99" + weekDay;
      case DateFormatKinds.ymdDotAd:
        return "9999.99.99" + weekDay;
      case DateFormatKinds.ymdDotJcE:
        return "99.99.99" + weekDay;
      case DateFormatKinds.ymStringAd:
        return "9999 年 99 月" + weekDay;
      case DateFormatKinds.ymStringJcEra:
        return "和暦 99 年 99 月" + weekDay;
      case DateFormatKinds.ymStringJc:
        return "99 年 99 月" + weekDay;
      case DateFormatKinds.ymDotJcE:
        return "99.99" + weekDay;
      case DateFormatKinds.mdStringAd:
        return "99 月 99 日" + weekDay;
      case DateFormatKinds.mdSlashAd:
        return "99 / 99" + weekDay;
      case DateFormatKinds.jcEra:
        return "和暦" + weekDay;
      case DateFormatKinds.jcE:
        return "和暦記号" + weekDay;
      default:
        return "";
    }
  }

  get timeFormat(): string {
    switch (this.timeStyle.formatKind) {
      case TimeFormatKinds.String12hJa:
        return "午前 99 時 99 分";
      case TimeFormatKinds.String12hEn:
        return "AM 99 時 99 分";
      case TimeFormatKinds.String12h:
      case TimeFormatKinds.String24h:
        return "99 時 99 分";
      case TimeFormatKinds.Colon12hEn:
        return "AM 99 : 99";
      case TimeFormatKinds.Colon12h:
      case TimeFormatKinds.Colon24h:
        return "99 : 99";
      default:
        return "";
    }
  }
}
